import { c as _c } from "react/compiler-runtime";
import { CopyIcon, MoreVerticalIcon, Trash2Icon } from 'lucide-react';
import { useLocale, useTranslations } from 'next-intl';
import { useState } from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { toast } from '@/components/ui/toast';
import { useCommentContext } from '@/contexts/comment.context';
import { useCommentsContext } from '@/contexts/comments.context';
import { useDeletePostComment } from '@/hooks/queries/comment.query';
import { useCopyToClipboard } from '@/hooks/use-copy-to-clipboard';
import { useSession } from '@/lib/auth-client';
import { getLocalizedPath } from '@/utils/get-localized-path';
export function CommentMenu() {
  const $ = _c(69);
  const {
    comment
  } = useCommentContext();
  const {
    slug
  } = useCommentsContext();
  const {
    data: session
  } = useSession();
  const [copy] = useCopyToClipboard();
  const [open, setOpen] = useState(false);
  const t = useTranslations();
  const locale = useLocale();
  let t0;
  if ($[0] !== slug) {
    t0 = {
      slug
    };
    $[0] = slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = () => {
      toast.add({
        type: "success",
        title: t("success.comment-deleted"),
        data: {
          testId: "comment-deleted-toast"
        }
      });
    };
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    mutate: deleteComment,
    isPending: isDeleting
  } = useDeletePostComment(t0, t1);
  const {
    isDeleted,
    id,
    user: t2,
    parentId
  } = comment;
  const {
    id: userId
  } = t2;
  const commentQuery = parentId ? `comment=${parentId}&reply=${id}` : `comment=${id}`;
  const t3 = `/blog/${slug}`;
  let t4;
  if ($[4] !== locale || $[5] !== t3) {
    t4 = getLocalizedPath(t3, locale);
    $[4] = locale;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const commentPath = t4;
  const isAuthor = !isDeleted && session?.user.id === userId;
  let t5;
  if ($[7] !== deleteComment || $[8] !== id || $[9] !== isDeleting) {
    t5 = function handleDeleteComment() {
      if (isDeleting) {
        return;
      }
      deleteComment({
        id
      });
    };
    $[7] = deleteComment;
    $[8] = id;
    $[9] = isDeleting;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleDeleteComment = t5;
  let t6;
  if ($[11] !== t) {
    t6 = t("blog.comments.open-menu");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MoreVerticalIcon />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6) {
    t8 = <DropdownMenuTrigger render={<Button variant="ghost" size="icon-sm" aria-label={t6} data-testid="comment-menu-button">{t7}</Button>} />;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== commentPath || $[17] !== commentQuery || $[18] !== copy || $[19] !== t) {
    t9 = () => {
      copy({
        text: `${globalThis.location.origin}${commentPath}?${commentQuery}`,
        successMessage: t("success.link-copied")
      });
    };
    $[16] = commentPath;
    $[17] = commentQuery;
    $[18] = copy;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CopyIcon />;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("blog.comments.copy-link");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <DropdownMenuItem onClick={t9}>{t10} {t11}</DropdownMenuItem>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== isAuthor || $[28] !== isDeleting || $[29] !== t) {
    t13 = isAuthor && <DropdownMenuItem disabled={isDeleting} aria-disabled={isDeleting} data-testid="comment-delete-button" variant="destructive" onClick={() => {
      setOpen(true);
    }}><Trash2Icon />{t("common.delete")}</DropdownMenuItem>;
    $[27] = isAuthor;
    $[28] = isDeleting;
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13) {
    t14 = <DropdownMenuContent align="end" className="min-w-36">{t12}{t13}</DropdownMenuContent>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14 || $[35] !== t8) {
    t15 = <DropdownMenu>{t8}{t14}</DropdownMenu>;
    $[34] = t14;
    $[35] = t8;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t) {
    t16 = t("common.dialogs.delete-comment.title");
    $[37] = t;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t16) {
    t17 = <AlertDialogTitle>{t16}</AlertDialogTitle>;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t) {
    t18 = t("common.dialogs.delete-comment.description");
    $[41] = t;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t18) {
    t19 = <AlertDialogDescription>{t18}</AlertDialogDescription>;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t17 || $[46] !== t19) {
    t20 = <AlertDialogHeader>{t17}{t19}</AlertDialogHeader>;
    $[45] = t17;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t) {
    t21 = t("common.cancel");
    $[48] = t;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t21) {
    t22 = <AlertDialogCancel>{t21}</AlertDialogCancel>;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t) {
    t23 = t("common.delete");
    $[52] = t;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== handleDeleteComment || $[55] !== t23) {
    t24 = <AlertDialogAction onClick={handleDeleteComment} variant="destructive" data-testid="comment-dialog-delete-button">{t23}</AlertDialogAction>;
    $[54] = handleDeleteComment;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t22 || $[58] !== t24) {
    t25 = <AlertDialogFooter>{t22}{t24}</AlertDialogFooter>;
    $[57] = t22;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== t20 || $[61] !== t25) {
    t26 = <AlertDialogContent data-testid="comment-dialog">{t20}{t25}</AlertDialogContent>;
    $[60] = t20;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== open || $[64] !== t26) {
    t27 = <AlertDialog open={open} onOpenChange={setOpen}>{t26}</AlertDialog>;
    $[63] = open;
    $[64] = t26;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== t15 || $[67] !== t27) {
    t28 = <>{t15}{t27}</>;
    $[66] = t15;
    $[67] = t27;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  return t28;
}